import { observable, action, toJS } from 'mobx';
import { messageList } from '../store/MessageList';
import Message from '../store/Message';
import { cleanArray } from '../utils';

class MultiSelectList {
  @observable name='';
  @observable allOptions = [];
  @observable checkedOptions = [];
  
  @observable anchorEl = null;

  @observable pasteMode = false;
  @observable transferList = [];

  @observable limit = null;
  @observable updated = false;
  @observable changed = false;
  
  constructor(name){
    this.name = name;
  }


  @action update = (allOptions, checkedOptions) => {
    this.transferList = [];
    this.allOptions = allOptions;
    this.checkedOptions = checkedOptions;
    this.updated = true;
    this.disableSearch();
  }

  @action close = () => {
    this.anchorEl = null};

  @action open = event => this.anchorEl = event.currentTarget;
  @action enableSearch = () => this.changed = true;
  @action disableSearch = () => this.changed = false;
  @action updateTransferList = event => this.transferList = event.target.value.split('\n');
  @action switchPasteMode = () => this.pasteMode = !this.pasteMode;
  @action clear = () => this.checkedOptions = [];


  @action revertChanges = values => {
    this.checkedOptions = values;
    this.transferList = []
    this.disableSearch();
    this.close();
  }


  get isOpen() {return Boolean(this.anchorEl)}
  get isChanged() {return Boolean(this.changed)}
  get isPasteMode() {return Boolean(this.pasteMode)}
  get isSearchDisabled() {return Boolean(!this.isChanged)}
  get isDownloadDisabled() {return Boolean((this.getCheckedOptions().length === 0))}
  get isSelectAll() {return Boolean(this.getAvailableOptions().length === 0)}


  getErrors() {return toJS(this.transferErrors)}
  getTransferList() {return toJS(this.transferList)}
  getCheckedOptions() {return toJS(this.checkedOptions)}
  getAllOptions() {return toJS(this.allOptions)}
  getAvailableOptions() {
    const checkedOptions = this.getCheckedOptions()
    return this.allOptions.filter(function(val) {
      return !checkedOptions.includes(val);
    });
  }

  getSearchTooltipTitle(){
  if(!this.isChanged) return "No changes made";
  return "";
}

getDownloadTooltipTitle() {
  if(this.getCheckedOptions().length === 0) return `Please select some ${this.name}`;
  if(this.isSelectAll) return `Download all ${this.name}`
  return `Download selected ${this.name}`;
}

// Check if array is valid
  isValidArray(array){
    if(array === null) return false
    else if(array[0] === '') return false;
    return true
  }

  filterOutCheckedOptions(values){
    const checkedOptions = this.getCheckedOptions()
    return values.filter(function(val) {return !checkedOptions.includes(val)})
  }

  @action selectAllOptions = () => {
    this.checkedOptions = this.getAllOptions();
    this.enableSearch()
  }

  @action addCheckedOption = values => {
    if(this.limit === null || this.getCheckedOptions().length < this.limit){
      const addValue = this.filterOutCheckedOptions(values)[0]
      this.checkedOptions.push(addValue);
      this.enableSearch()
    } else {
      messageList.push(new Message(`You cannot select more than ${this.limit} ${this.name}`,'error'))
    }
  };

  @action removeCheckedOption = values => {    
    const checkedOptions = this.getCheckedOptions() 
    const removeValue = values.filter(function(val) {return checkedOptions.includes(val)})[0]
    this.checkedOptions.splice(this.checkedOptions.indexOf(removeValue),1);
    this.enableSearch()  
  };


  @action handleTransfer = () => {
    // Get transfer list, clean array (remove whitespaces and duplicates), and remove checked options.
    const transferList = this.filterOutCheckedOptions(cleanArray(this.getTransferList()));

    // Filter out options that are not available and count errors
    let transferErrors = 0
    const allOptions = this.getAllOptions()
    const availableTransferOptions = transferList.filter(function(transferItem) {
      if (!allOptions.includes(transferItem)) 
        transferErrors++;
      return allOptions.includes(transferItem)
    })

    // Display error message and highlight number of options that do not exist
    if(transferErrors > 0 && (messageList.length < 2)) messageList.push(new Message(
      `${transferErrors} out of ${transferList.length} ${this.name} not found`, 'error'
      ));
    
    // Transfer Step.
    // Handle selection limit if any
    if(this.limit == null){      
      // Push transfer options to checked options
      console.log('push transfer options to checked options')
      availableTransferOptions.forEach(item => {
        this.checkedOptions.push(item)
      });
    } else {
      // Adjust transfer limit if there are checked options
      const transferLimit = this.limit - this.getCheckedOptions().length;
      
      // Push transfer options to checked options
      for(var i = 0; i < Math.min(transferLimit, availableTransferOptions.length); i++){
        this.checkedOptions.push(availableTransferOptions[i])
      }

      // Display error message if transfer options exceed limit
      if(messageList.length < 2 && transferLimit < availableTransferOptions.length) 
        messageList.push(new Message(`You cannot select more than ${this.limit} ${this.name}`,'error'))
      }
  }
}

export default MultiSelectList;